import {convertRowsToData} from '../utils/dataUtils'

export default function ParallelCoordsDataController (rows){ //},config={}) {
  let headers = rows[0]
  let propperHeaders = ['id',...headers.slice(1)]
  let data = convertRowsToData([propperHeaders,...rows.slice(1)],headers.length-1)  

  return data.map((d)=>{
    let dims = d.value.map((d)=>d.id)
    return {
      id: d.id,
      dimensions: dims.reduce((res,dim)=>{
        if(dim!=='id') res[dim] = +d.value.find((dd)=>dd.id===dim).value
        return res
      },{})
    }
  })
}